import React from 'react';
import FadeIn from '../ui/FadeIn';
import Button from '../ui/Button';

const TransitionSection = () => {
  const scrollToForm = () => {
    const element = document.getElementById('inquire');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="bg-charcoal pt-10 pb-20 md:pt-28 md:pb-32 px-5 md:px-6 flex items-center justify-center relative">
      <div className="max-w-4xl mx-auto text-center">
        <FadeIn direction="up">
          <h2 className="font-serif text-[34px] leading-[1.15] md:text-6xl lg:text-7xl text-ivory mb-8 max-w-3xl mx-auto">
            A Prime Season Date <br className="hidden md:block" />
            <span className="italic text-gold">Worth Claiming</span>
          </h2>
          
          <p className="text-stone font-serif italic text-lg md:text-xl mb-12 max-w-2xl mx-auto leading-relaxed">
            October 17 stands as one of the most coveted Saturdays of the year. A rare opening at Padua Estate for the couple who recognizes an exceptional opportunity.
          </p>
        </FadeIn>
        
        <FadeIn delay={0.2} direction="up">
          <Button 
            variant="primary" 
            onClick={scrollToForm} 
            className="w-full md:w-auto px-16 py-5 min-h-[60px]"
          >
            Inquire About October 17
          </Button>
        </FadeIn>
      </div>
    </section>
  );
};

export default TransitionSection;